import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { useDeprecatedComponentWarning } from '@nerdwallet/deprecate';
import { useIconProps } from '../useIconProps';

var Lock = function Lock(props) {
  useDeprecatedComponentWarning({
    component: 'Lock'
  });
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 2048 2048"
  }, useIconProps(props)), /*#__PURE__*/React.createElement("path", {
    d: "M944 1280q60 0 102 42.5t42 101.5q0 77-64 120v120H864v-120q-64-43-64-120 0-59 42-101.5t102-42.5zm528-319q81 6 136.5 66t55.5 141v576q0 86-61 147t-147 61H432q-86 0-147-61t-61-147v-576q0-81 55.5-141T416 961V816q0-143 71-264.5T679.5 359 944 288t264.5 71T1401 551.5t71 264.5v145zm32 783v-576q0-20-14-34t-34-14H704V960h608V816q0-152-108-260T944 448 684 556 576 816v304H432q-20 0-34 14t-14 34v576q0 20 14 34t34 14h1024q20 0 34-14t14-34z"
  }));
};

Lock.displayName = 'Lock';

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require
  var PropTypes = require('prop-types');

  Lock.propTypes = {
    className: PropTypes.string,
    color: PropTypes.string,
    size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    textAligned: PropTypes.bool
  };
}

export default Lock;